var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Visa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16,
    rx: 2,
    ry: 2,
    style: {
      fill: "#224dba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91,10.88H6.4L5.26,6.35a.74.74,0,0,0-.33-.48A4.51,4.51,0,0,0,3.55,5.4V5.22H6a.65.65,0,0,1,.63.57L7.2,9.05,8.71,5.22h1.47Zm3.11,0H9.59l1.17-5.66h1.43Zm3-4.09a.55.55,0,0,1,.59-.48A2.64,2.64,0,0,1,16,6.57l.25-1.22A3.43,3.43,0,0,0,15,5.09c-1.38,0-2.39.78-2.39,1.87a1.83,1.83,0,0,0,1.21,1.52c.55.26.76.44.72.7a.72.72,0,0,1-.84.57h0a3.41,3.41,0,0,1-1.47-.34l-.25,1.21a3.94,3.94,0,0,0,1.55.31C15,11,16,10.18,16,9c0-1.48-2-1.57-2-2.22h0Zm7,4.09L19.87,5.22H18.66a.63.63,0,0,0-.59.44L16,10.88h1.47l.29-.83h1.81l.16.83ZM18.87,6.74l.42,2.13H18.11Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.b1d9d299833b5183121507d59782ae55.svg";
export { ForwardRef as ReactComponent };